
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.708 9.959a.25.25 0 11-.001 0h.001m3.5 0a.25.25 0 11-.001 0h.001m3.5 0a.25.25 0 11-.001 0h0M2.5 12.5h13a1 1 0 011 1v2a1 1 0 01-1 1h-13a1 1 0 01-1-1v-2a1 1 0 011-1zm10-7v-2m-1-2h2a1 1 0 110 2h-2a1 1 0 110-2zm-6 6h4m-5-2h-.567a1 1 0 00-1 .929L2.5 12.5m13 0l-.433-6.071a1 1 0 00-1-.929H10.5m-2-2l-2 .5v3.5h2zm-1 11h3","stroke":"currentColor","stroke-width":"1.5","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    